import { z } from "zod";
import { idSchema, isoDateSchema, optionalText, positiveCentsSchema, settlementMethodSchema, } from "./common.js";
/** Um acerto: "fulano ja me pagou". E o que zera a divida sem apagar historico. */
export const createSettlementSchema = z
    .object({
    fromPersonId: idSchema,
    toPersonId: idSchema,
    amountCents: positiveCentsSchema,
    method: settlementMethodSchema.default("PIX"),
    paidAt: isoDateSchema.optional(),
    note: optionalText(200).nullable(),
})
    .refine((data) => data.fromPersonId !== data.toPersonId, {
    message: "Uma pessoa não pode pagar a si mesma.",
    path: ["toPersonId"],
});
/** Quita o grupo inteiro de uma vez, gravando um acerto por transferencia sugerida. */
export const settleAllSchema = z.object({
    mode: z.enum(["pairwise", "simplified"]).default("pairwise"),
});
//# sourceMappingURL=settlement.js.map